<template>
  <div style=" margin-bottom: 40px;">
    <div class="leave-word">
      <div class="title">留言反馈</div>
      <div class="line"></div>
      <div>
        <el-form :model="filterForm" :rules="rules" ref="filterForm">
          <el-form-item label="留言类型:" prop="messageType">
            <el-radio :key="item.label" :label="item.label" v-for="item in options" v-model="filterForm.messageType">{{item.title}}</el-radio>
          </el-form-item>
          <el-form-item label="您的建议或问题:" prop="content">
            <el-input :autosize="{ minRows: 10,}" maxlength="500" placeholder="请输入内容" show-word-limit type="textarea" v-model="filterForm.content"></el-input>
          </el-form-item>
          <el-button @click="submitForm('filterForm')" class="submitBtn">保存</el-button>
        </el-form>
      </div>
    </div>
    <div class="leave-list">
      <div class="title">留言记录</div>
      <div class="line" style="margin-bottom:0;"></div>
      <div v-if="messageList.length > 0">
        <ul :key="index" class="ul" v-for="(item,index) in messageList">
          <li class="li">
            <div class="leave-box">
              <p class="leave-time">{{$store.getters.unixTime(item.messageTime).substring(0, 9)}}</p>
              <p class="leave-text">{{item.content}}</p>
            </div>
            <div @click="delClick(item)" @mouseenter="Enter(index)" @mouseleave="Leave(index)" class="img-box">
              <img alt="" class="img-icon" src="../../../assets/image/reader/del_icon1.png" v-if="index==current">
              <img alt="" class="img-icon" src="../../../assets/image/reader/del_icon.png" v-else>
            </div>
          </li>
        </ul>
      </div>
      <div v-else>
        <el-empty :description="empty"></el-empty>
      </div>
    </div>
    <Page :page="page" :size="limit" :total="count" @onPage="onPage"></Page>
  </div>
</template>

<script>
  import Page from "../../../components/common/Page.vue"
  import {addMessage, deleteMessageById, listMessage} from "../../../utils/router/reader.api";

  export default {
    components: {Page},
    data() {
      return {
        options: [
          // { label: 1, title: "网站技术问题" },
          // { label: 2, title: "用户体验问题" },
          {label: 1, title: "平台建议"},
          {label: 2, title: "其他问题"},
        ],
        filterForm: {
          content: "",
          messageType: "",
        },
        contentText: "",
        rules: {
          messageType: [{required: true, message: "请选择", trigger: "blur"}],
          content: [{required: true, message: "请填写"}],
        },
        count: 0,
        limit: 3,
        page: 1,
        empty: "暂无留言",
        current: -1,
        messageList: [],
      };
    },
    methods: {
      submitForm(formName) {
        if (this.filterForm.content == this.contentText) {
          this.$message("您的问题已经提交，请不要重复提交问题");
          return;
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.contentText = this.filterForm.content;
            this.filterForm.userName = this.$store.state.userInfo.userName;
            this.filterForm.userId = this.$store.state.userInfo.userId;
            this.filterForm.typeId = this.$store.state.typeId;
            this.add();
            this.getMessageList()
          } else {
            this.$message("请选择类型和填写留言内容");
            return false;
          }
        });
      },
      add() {
        addMessage(this.filterForm).then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: "添加留言成功，我们会尽快给您回复",
              type: "success",
            });
          }
        });
      },
      Enter(index) {
        this.current = index;
      },
      Leave() {
        this.current = null;
      },
      getMessageList() {
        listMessage({
          typeId: this.$store.state.typeId,
          userId: this.$store.state.userInfo.userId,
          limit: this.limit,
          page: this.page,
        }).then(res => {
          if (res.data.data && res.data.code === 200) {
            this.count = res.data.data.count
            this.messageList = res.data.data.list || []
          }
        })
      },
      delClick(row) {
        deleteMessageById({
          id: row.id,
          userId: this.$store.state.userInfo.userId,
        }).then(res => {
          if (res && res.data.code === 200) {
            this.getMessageList()
          } else {
            this.$alert(res.data.message)
          }
        })
      },
      onPage(page) {
        this.page = page
        this.getMessageList()
      },
    },
    mounted() {
      this.getMessageList()
    }
  };
</script>

<style lang="less" scoped>
  .leave-word {
    width: 100%;
    padding-left: 30px;
    background: #fff;
    padding: 20px;

    .submitBtn {
      width: 6.25rem;
      height: 2.396rem;
      background-color: #8c322f;
      border-radius: 0.208rem;
      color: #fff;
      font-size: 0.833rem;
    }

    /deep/ .el-radio__input.is-checked .el-radio__inner {
      background-color: #8c322f;
    }

    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: #8c322f;
      font-size: 0.833rem;
    }

    /deep/ .el-radio__input.is-checked .el-radio__inner {
      border: none;
    }

    /deep/ .el-input__inner:focus {
      border: 1px solid #8c322f;
    }

    /deep/ .el-input__inner {
      height: 40px;
    }

    /deep/ .el-form-item__label {
      font-size: 0.833rem;
    }

    /deep/ .el-radio__label {
      font-size: 0.833rem;
    }

    /deep/ .el-textarea {
      font-size: 15px;
    }

    /deep/ .el-textarea :focus {
      border: solid 0.052rem #bbbbbb;
    }
  }

  .title {
    color: #333333;
    font-size: 1.146rem;
    border-left: 0.26rem solid #b1222b;
    padding-left: 0.573rem;
  }

  .line {
    border-bottom: 0.052rem solid #ddd;
    margin-top: 0.781rem;
    margin-bottom: 1.563rem;
  }

  .leave-list {
    min-height: 300px;
    background-color: #fff;
    padding: 20px;
    margin-top: 20px;

    .title {
      margin: 0;
    }

    .ul {
      border-bottom: solid 1px #dddddd;
      padding-bottom: 1rem;

      .li {
        display: flex;
        padding-right: 20px;
        justify-content: space-between;
      }

      .leave-box {
        padding-top: 0.194rem;
      }

      .leave-time {
        color: #aaaaaa;
        font-size: 14px;
        line-height: 32px;
        letter-spacing: 1px;
      }

      .leave-text {
        color: #333333;
        line-height: 26px;
        font-size: 16px;
      }

      .img-icon {
        width: 18px;
        height: 16px;
      }

      .img-box {
        width: 50px;
        height: 28px;
        cursor: pointer;
        border-radius: 4px;
        position: relative;
        top: 40px;
        padding: 4px 16px;
      }

      .img-box:hover {
        background-color: #8c322f;
      }
    }
  }
</style>
